import { CLessonInCourse } from '@yandex-int/k-common';
import { H1, Text, Spin, useStaticUrls } from 'platform-components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import ym from 'react-yandex-metrika';

import PageContentTitle from 'common.components/page-content-title/page-content-title';
import { SpecCourseLessons } from 'common.components/spec-course-lessons/spec-course-lessons';
import { SpecCourseStub } from 'common.components/spec-course-stub/spec-course-stub';
import { SpecCourseTabs } from 'common.components/spec-course-tabs/spec-course-tabs';
import { SPEC_COURSE_LESSON_STATUS } from 'common.components/spec-course/typings';

import { SpecCourseLessonsPageBanner } from '../__banner/lessons-page__banner';
import { getSpecCourseLessonStatus } from '../../spec-course.store/utils';
import { Params as SpecCourseParams } from '../lessons-page.container';
import { getShouldShowSpecCourseBanner } from '../selectors';

import './lessons-page__content.scss';

interface Props {
    activeClessons: Array<CLessonInCourse>;
    completedClessons: Array<CLessonInCourse>;
    hasNoLessons: boolean;
    onLessonClick: (status: SPEC_COURSE_LESSON_STATUS, lessonId: number) => void;
    shouldShowStudentsWarning: boolean;
    teamLetter: string | null;

    /** Грейд класса */
    teamNumber: number | null;

    isLoading: boolean;
}

// eslint-disable-next-line complexity
export const SpecCourseLessonsPageContent = ({
    onLessonClick,
    teamNumber,
    teamLetter,
    activeClessons,
    completedClessons,
    shouldShowStudentsWarning,
    isLoading,
    hasNoLessons,
}: Props) => {
    const { labClassSpecCourseLesson } = useStaticUrls();
    const [isActive, setActive] = useState(true);
    const activeCount = activeClessons && activeClessons.length;
    const completedCount = completedClessons && completedClessons.length;
    const shouldShowTabs = Boolean(activeCount && completedCount);

    const { classId: clId } = useParams<SpecCourseParams>();
    const classId = Number(clId);

    const shouldShowRoverBanner = useSelector((store) => getShouldShowSpecCourseBanner(store, { classId }));

    useEffect(
        function sendMetrika() {
            if (hasNoLessons) {
                ym('reachGoal', 'teacher_olymp_empty_state');
            }
        },
        [hasNoLessons]
    );

    const title = (
        <div className="spec-course-lessons-page__page-content-title">
            <PageContentTitle title={<H1 id="specCourse.content.title" values={{ teamLetter, teamNumber }} />} />
        </div>
    );

    if (hasNoLessons) {
        return (
            <div className="spec-course-lessons-page__content">
                {title}

                <div className="spec-course-lessons-page__stub-wrapper">
                    <SpecCourseStub textId="specCourse.stub.teacher" />
                </div>
            </div>
        );
    }

    const onTabClick = () => {
        setActive(!isActive);
    };

    let clessons: Array<CLessonInCourse> = [];
    if (shouldShowTabs) {
        clessons = isActive ? activeClessons : completedClessons;
    } else {
        clessons.push(...activeClessons, ...completedClessons);
    }

    return (
        <div className="spec-course-lessons-page__content">
            {title}

            {shouldShowStudentsWarning && (
                <div className="spec-course-lessons-page__students-warning">
                    <Text id="specCourse.studentsWarning" size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN} />
                </div>
            )}
            {shouldShowTabs && <SpecCourseTabs isActive={isActive} onTabClick={onTabClick} />}
            {isLoading ? (
                <Spin center />
            ) : (
                <>
                    {shouldShowRoverBanner && <SpecCourseLessonsPageBanner />}
                    <SpecCourseLessons
                        clessons={clessons}
                        getStatusUtil={getSpecCourseLessonStatus}
                        lessonUrl={labClassSpecCourseLesson}
                        onLessonClick={onLessonClick}
                    />
                </>
            )}
        </div>
    );
};
